import React, { useState, useEffect } from "react";
// import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@material-ui/data-grid";
import EquipmentRefreshData from "./EquipmentRefreshData";
import EquipmentAdvFilter from "./EquipmentAdvFilter";
import Cookies from "js-cookie";
const _ = require("lodash");
const axios = require("axios");

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomToolbar = ({
  handleRefreshData,
  listOfequipmentIDs,
  handleMultipleEquipmentID,
  handleClear,
  selectedIDs,
}) => {
  const [open, setOpen] = useState(false);

  let modalWidth = 600;
  let modalHeight = 380;

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: modalWidth,
      height: modalHeight,
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #26477c",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));

  const classes = useStyles();

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <GridToolbarContainer>
      {/* <GridToolbarColumnsButton
        style={{
          fontFamily: 'Roboto',
          fontWeight: '500',
          fontSize: '0.8125rem',
          color: '#272c34',
        }}
      />
      &nbsp;&nbsp; */}
      <EquipmentRefreshData handleRefreshData={handleRefreshData} />
      &nbsp; &nbsp;
      {/* <div
        onClick={() => {
          return (
            <GridToolbarColumnsButton
              style={{
                fontFamily: 'Roboto',
                fontWeight: '500',
                fontSize: '0.8125rem',
                color: '#272c34',
              }}
            />
          );
        }}>
        hii
      </div> */}
      <EquipmentAdvFilter
        theme={theme}
        classes={classes}
        getStyles={getStyles}
        MenuProps={MenuProps}
        listOfequipmentIDs={listOfequipmentIDs}
        handleMultipleEquipmentID={handleMultipleEquipmentID}
        handleClear={handleClear}
        selectedIDs={selectedIDs}
      />
      &nbsp;&nbsp;
      <GridToolbarFilterButton
        style={{
          fontFamily: "Roboto",
          fontWeight: "500",
          fontSize: "0.8125rem",
          color: "#26477c",
        }}
      />
    </GridToolbarContainer>
  );
};

const Equipment = ({ currentOrganisation, reportData, reportDataFields }) => {
  const [refreshEquipmentData, setEquipmentData] = useState(false);
  const [EquipmentIDs, setEquipmentIDs] = useState([]);

  const handleMultipleEquipmentID = (event) => {
    setEquipmentIDs(event.target.value);
  };

  const handleClear = () => {
    setEquipmentIDs([]);
  };

  const handleRefreshData = () => {
    let authObj = Cookies.get("authObj");
    authObj = JSON.parse(authObj);
    let { token } = authObj;
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };
    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
    };
    axios
      .get(
        `${process.env.REACT_APP_API}/getReportAndEquipmentData/${currentOrganisation}`,
        config
      )
      .then((response) => {
        setEquipmentData(response.data.result);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  let allPropsLoaded = currentOrganisation && reportData && reportDataFields;
  allPropsLoaded = allPropsLoaded && reportData[currentOrganisation];
  if (allPropsLoaded) {
    reportDataFields = reportDataFields.find((eField) => {
      return eField.organisation === currentOrganisation;
    });

    let headerNames =
      reportDataFields["reportInformation"]["Equipment"]["ReportFields"][
        "renderedFields"
      ];

    let dataFields =
      reportDataFields["reportInformation"]["Equipment"]["ReportFields"][
        "dbfields"
      ];

    let dataCol = [
      {
        editable: false,
        hide: true,
        headerName: "#",
        field: "id",
      },
    ];

    for (let i = 0; i < headerNames.length; i++) {
      let headerName = headerNames[i];
      let dataField = dataFields[i];
      let column = {
        editable: false,
        hide: false,
      };

      if (dataField !== "Level") {
        column["headerName"] = headerName;
        column["field"] = dataField;
      }

      // if (dataField === "TimeStamp" && currentOrganisation === "ntuGomic") {
      //   column["headerName"] = "TimeStamp";
      //   column["field"] = "ts";
      // }
      switch (dataField) {
        case "EquipmentID":
          column["width"] = 180;
          break;
        case "FilledLevel":
          column["width"] = 220;
          break;
        case "Level":
          column["width"] = 130;
          break;
        case "Temperature":
          column["width"] = 200;
          break;
        case "address":
          column["width"] = 220;
          break;
        case "TimeStamp":
          column["width"] = 180;
          break;
        case "WeightValue":
          column["width"] = 230;
          break;
        default:
      }
      dataCol.push(column);
    }

    let levelHeaderName = headerNames[headerNames.length - 1];
    dataCol = [
      ...dataCol,
      {
        field: "Level",
        headerName: levelHeaderName,
        width: 180,
        renderCell: (params) => {
          let color = params.row.Level;
          let imageSrc = `https://imagesmapicon.s3.ap-southeast-1.amazonaws.com/${color}dot.png`;
          return <img width="30" height="30" src={imageSrc} />;
        },
      },
    ];

    if (refreshEquipmentData) {
      reportData = refreshEquipmentData;
    }

    let [equipmentData] = reportData[currentOrganisation];
    equipmentData = equipmentData["Equipment"]["equipmentInformation"];
    equipmentData = equipmentData.map((equip) => {
      equip["id"] = equip["EquipmentID"];
      return equip;
    });

    let equipmentIDs = equipmentData.map((equip) => equip.EquipmentID);

    equipmentData = equipmentData.map((equipment) => {
      let { TimeStamp } = equipment;

      if (TimeStamp) {
        let [date, time] = TimeStamp.split(" ");
        let [year, month, day] = date.split("-");

        let ts = `${day}-${month}-${year} ${time}`;
        equipment["ts"] = ts;
      }

      return equipment;
    });

    if (currentOrganisation === "ntuGomic") {
      dataCol = dataCol.map((col) => {
        if (
          col.headerName === "TimeStamp" &&
          currentOrganisation === "ntuGomic"
        ) {
          col.hide = true;
        }
        return col;
      });
      let tsIndex = 0;

      for (let i = 0; i < dataCol.length; i++) {
        let col = dataCol[i];
        if (col.field === "TimeStamp") {
          tsIndex = i + 1;
        }
      }

      dataCol.splice(2, 0, {
        editable: false,
        hide: false,
        width: 180,
        headerName: "TimeStamp",
        field: "ts",
      });
    }

    equipmentIDs = equipmentIDs.sort();

    let orgReport = [];
    if (EquipmentIDs.length > 0) {
      equipmentData.forEach((data) => {
        EquipmentIDs.forEach((ids) => {
          if (data.EquipmentID === ids) {
            orgReport.push(data);
          }
        });
      });
    }

    if (orgReport.length > 0 || EquipmentIDs.length > 0) {
      equipmentData = orgReport;
      orgReport = undefined;
    }

    equipmentData = equipmentData.map((equip) => {
      if (!equip["TimeStamp"]) {
        equip["TimeStamp"] = "No Data";
      }

      if (equip["WeightValue"] < 0) {
        equip["WeightValue"] = 0;
      } else {
        equip["WeightValue"] = Math.round(equip["WeightValue"] * 10) / 10;
      }

      if (equip["FilledLevel"] < 0) {
        equip["FilledLevel"] = 0;
      } else {
        equip["FilledLevel"] = Math.round(equip["FilledLevel"] * 10) / 10;
      }

      return equip;
    });

    for (let i = 0; i < equipmentData.length; i++) {
      equipmentData[i]["id"] = i + 1;
    }

    // let datagridData = { columns: dataCol, rows: equipmentData };
    return (
      <div style={{ height: 650, width: "100%" }}>
        <ThemeProvider theme={theme}>
          <DataGrid
            GridColDef={{ align: "center" }}
            components={{
              Toolbar: CustomToolbar,
              // ColumnFilteredIcon: CustomToolbar,
            }}
            componentsProps={{
              toolbar: {
                handleRefreshData: handleRefreshData,
                listOfequipmentIDs: equipmentIDs,
                selectedIDs: EquipmentIDs,
                handleMultipleEquipmentID: handleMultipleEquipmentID,
                handleClear: handleClear,
              },
            }}
            rows={equipmentData}
            columns={dataCol}
            sortModel={[
              {
                field: "TimeStamp",
                sort: "desc",
              },
            ]}
            filterModel={{
              items: [
                // {
                //   columnField: 'commodity',
                //   operatorValue: 'contains',
                //   value: 'rice',
                // },
              ],
            }}
          />
        </ThemeProvider>
      </div>
    );
  } else {
    return <div>Loading equipment lists....</div>;
  }
};

export default Equipment;
